import SuperFetch from '../../../superFetch.js';

class RecommendSearchWordApi {
  /**
   *  [추천 검색 키워드 리스트] 추천 검색 키워드 리스트 요청하기
   */
  getRecommendSearchWordList = (data) => SuperFetch.post('/recommend/searchWord/list', data);

  /**
   *  [추천 검색 키워드 상세] 추천 검색 키워드 상세 요청하기
   */
  getRecommendSearchWordDetail = (data) => SuperFetch.post('/recommend/searchWord/detail', data);

  /**
   *  추천 검색 키워드 복사하기 전 필요한 데이터 가져오기
   */
  prepareCopyRecommendSearchWord = (data) => SuperFetch.post('/recommend/searchWord/insert/preparation/copy', data);

  /**
   *  추천 검색 키워드 등록하기 전 필요한 데이터 가져오기
   */
  prepareCreateRecommendSearchWord = (data) => SuperFetch.post('/recommend/searchWord/insert/preparation/insert', data);

  /**
   *  추천 검색 키워드에 연결할 아이템 리스트 요청하기
   */
  getRecommendSearchWordItemList = (data) => SuperFetch.post('/recommend/searchWord/insert/preparation/list', data);

  /**
   *  추천 검색 키워드 등록/복사하기
   */
  copyRecommendSearchWord = (data) => SuperFetch.post('/recommend/searchWord/insert', data);

  /**
   *  전체 검색 키워드 리스트 EXCEL 다운로드
   */
  getRecommendSearchWordItemListExcelDownload = (data) =>
    SuperFetch.post('/recommend/searchWord/insert/preparation/list/excel/download', data);

  /**
   *  선택된 검색 키워드 리스트 EXCEL 다운로드
   */
  getSelectedRecommendSearchWordItemListExcelDownload = (data) =>
    SuperFetch.post('/recommend/searchWord/insert/preparation/list/excel/download/selected', data);

  /**
   *  검색 키워드 리스트 EXCEL 업로드
   */
  setRecommendSearchWordItemListExcelUpload = (data) =>
    SuperFetch.post('/recommend/searchWord/insert/preparation/list/excel/upload', data);
}

export default new RecommendSearchWordApi();
